import { ExpauseLoadingIndicator } from './ExpauseLoadingIndicator';
import { useTheme } from '../../../contexts/ThemeContext';
import { useResponsiveDesign } from '../../../responsiveDesign/responsiveDesign';
import { useLocale } from '../../../contexts/LocaleContext';
import { FONT_CONSTANTS } from '@/presentation/constants/fontConstants';
import { qaAttr, type QaAttrOptions } from '@/presentation/utils/qaAttr';

interface LoadingIndicatorProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Optional QA tag override forwarded to the spinner. */
  qa?: QaAttrOptions;
}

export const AnimatedLoadingIndicator = ({ size = 'md', className = '', qa }: LoadingIndicatorProps) => {
  const sizeMap = {
    sm: 16,
    md: 24,
    lg: 32,
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <ExpauseLoadingIndicator size={sizeMap[size]} qa={qa} />
    </div>
  );
};

export const LogoLoadingIndicator = () => {
  const { theme } = useTheme();

  return (
    <div
      {...qaAttr({ id: 'loading-indicator', status: 'loading' })}
      className="min-h-screen flex flex-col items-center justify-center"
      style={{ backgroundColor: theme.background }}
    >
      <div className="text-center">
        <img
          src="/logo.png"
          alt="Expause"
          className="w-24 h-24 mx-auto mb-4 animate-pulse"
        />
      </div>
    </div>
  );
};

// Text-based logo loading screen component (matches index.html loading logo)
export const LogoTextBrandFontLoadingIndicator = () => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();
  const { l10n } = useLocale();

  return (
    <div
      {...qaAttr({ id: 'loading-indicator', status: 'loading' })}
      className="min-h-screen flex flex-col items-center justify-center"
      style={{ backgroundColor: theme.background }}
    >
      <div className="text-center">
        <div
          className="mb-4"
          style={{
            fontFamily: FONT_CONSTANTS.logoFamily,
            fontSize: responsive.font['10xl'],
            color: theme.exclusive
          }}
        >
          {l10n.common.logoText}
        </div>
      </div>
    </div>
  );
};